/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Palette

Values: Default=Default, Blue=Blue, Grey=Grey, Purple=Purple, Green=Green, Pink=Pink, DeepBlue=DeepBlue
 * @export
 * @enum {string}
 */

export enum Palette {
    Default = 'Default',
    Blue = 'Blue',
    Grey = 'Grey',
    Purple = 'Purple',
    Green = 'Green',
    Pink = 'Pink',
    DeepBlue = 'DeepBlue'
}


